// extracted by mini-css-extract-plugin
module.exports = {"notifications":"DashboardNotifications_notifications__1qt5V"};